const cleanTextMessage = (textMessage) => {
  const charactersToRemove = ["\u200b", "\u200e"];
  const charactersToRemoveRegex = new RegExp(charactersToRemove.join("|"), "g");
  return textMessage.replace(charactersToRemoveRegex, "");
};

export default cleanTextMessage;